import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <Section tone="white" data-id="element-94" data-mp="26k9wgfyh77aw">
      <Eyebrow data-id="element-95" data-mp="22l13vef69fgx">La transformación</Eyebrow>
      <Heading data-id="element-96" data-mp="22m2ejhs9zzy4">
        De la incertidumbre clínica a la <span className="italic text-brand" data-id="element-97" data-mp="2zb1nkz0op5rd">seguridad</span> en cada
        consulta
      </Heading>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 sm:gap-5" data-id="element-98" data-mp="2ubxes9ho9a1k">
        <div className="rounded-3xl border border-bad/20 bg-bad/[0.04] p-4 sm:p-5" data-id="element-99" data-mp="2ucqeiqi7qza7">
          <p className="mb-3.5 flex items-center gap-2 text-[12px] font-extrabold uppercase tracking-[0.16em] text-bad" data-id="element-100" data-mp="2q90w6is4tdxm">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-bad/15" data-id="element-101" data-mp="2ldd49vm9m6of">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-102" data-mp="1ewhsgq0tsmkm" />
            </span>
            Antes
          </p>
          <ul className="space-y-3" data-id="element-103" data-mp="19ygdag6it7ef">
            {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-104" data-mp="1765lahtnhyqn">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-bad" aria-hidden="true" data-id="element-105" data-mp="1c3e5sp29uev2" />
                <span className="text-[14px] leading-snug text-navy/70 sm:text-[15px]" data-id="element-106" data-mp="y5h6vm0chwd8">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border-2 border-good/30 bg-good/[0.05] p-4 sm:p-5" data-id="element-107" data-mp="135loxggwiz5k">
          <p className="mb-3.5 flex items-center gap-2 text-[12px] font-extrabold uppercase tracking-[0.16em] text-good" data-id="element-108" data-mp="ocrwyvkg0qk0">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-good/15" data-id="element-109" data-mp="fe6lfkde2bsq">
              <CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-110" data-mp="jfrsuq75lxvj" />
            </span>
            Después
          </p>
          <ul className="space-y-3" data-id="element-111" data-mp="5fh01hmaa97q">
            {afterItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-112" data-mp="af3nskzqn7us">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-good" aria-hidden="true" data-id="element-113" data-mp="aebrf7ybh63g" />
                <span className="text-[14px] font-semibold leading-snug text-navy sm:text-[15px]" data-id="element-114" data-mp="2c5u1u3v4a4d2">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <SectionCTA promise="Pasa a la columna verde en tu próxima consulta, no el año que viene." label="Quiero llegar preparado a cada consulta" data-id="element-115" data-mp="239uxgr71k33h" />
    </Section>;
}